<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__header">
			<h2 class="styled-form__title">Please verify your new email address</h2>

			<h3 class="styled-form__subtitle" v-if="!showEmail">We have sent an email to <span class="styled-form__highlighted">{{ data.email.toLowerCase() }}</span>, please copy the code in the email and paste into the field below</h3>
			<h3 class="styled-form__subtitle" v-else>We have sent you an email, please copy the code in the email and paste into the field below</h3>
		</div>

		<div class="styled-form__field styled-form__field--centered">
			<span
				:class="['styled-form__error', {'is-visible': errors.code}]"
			>{{ errors.code }}</span>

			<input
				v-model="data.code"
				:class="['styled-form__input', {'is-invalid': errors.code}]"
				name="code"
				:style="{
					width: '230px'
				}"
			>
		</div>

		<div class="text--center">
			<button class="btn" :disabled="isLoading">Continue</button>
		</div>
	</form>
</template>

<style>
	.styled-form__header {
		margin-bottom: 20px;
	}

</style>

<script>
	import { mapState } from 'vuex';
	import GlobalMessage from '../messages/GlobalMessage.vue';
    import isEmail from '../../helpers/isEmail';
    import FormInput from '../formFields/FormInput.vue';

	export default {
    components: {
      FormInput,
      GlobalMessage
    },
    props: {
      submit: {
        type: Function,
        required: true
      },
      email: String,
      code: String
    },
    data() {
      return {
        isLoading: false,
        data: {
          email: '',
          code: ''
        },
        errors: {},
        showEmail: true
      }
    },
    created() {
      this.validateProps();
    },
    methods: {
      validateProps() {
        if (isEmail(this.email)) {
          let emailProp = this.email;
          this.data.email = emailProp.toLowerCase();
          this.showEmail = false;
        }
      },
      onSubmit() {
        this.errors = this.validate(this.data);
        if (Object.keys(this.errors).length === 0) {
          this.isLoading = true;
          this.data.email = this.data.email.toLowerCase();
          this.submit(this.data).catch(errors => {
            this.isLoading = false;
            this.errors = errors;
          });
        }
      },
      validate(data) {
        const errors = {};

        if (!data.code.length) {
          errors.code = 'This field is required';
        } else if (!(/^\d+$/.test(data.code))) {
          errors.code = 'This field can only contain numeric values';
        }

        return errors;
      }
    }
  };
</script>
